<template>
    <div class="tabs" :style="{height}" ref="tabs">
        <div
            class="tabs-content"
            :class="{'tabs-fix': fixed}"
            ref="tabContent"
            :style="{width: width + 'px'}"
        >
            <ul class="tabs-main">
                <li
                    v-if="firstTab"
                    :class="{'tabs-active': -1 === currentIdx}"
                    @click.stop="handleClickMainItem(-1)"
                >
                    <span>{{firstTab}}</span>
                    <img src="@/common/images/tabs/active.svg">
                </li>
                <li
                    v-for="(item, idx) in tabs"
                    :class="{'tabs-active': idx === currentIdx}"
                    :key="idx"
                    @click.stop="handleClickMainItem(idx)"
                >
                    <span>{{item[tabLabel]}}</span>
                    <img src="@/common/images/tabs/active.svg">
                </li>
            </ul>
            <ul class="tabs-sub" v-if="tags && tags.length">
                <li
                    v-if="firstTag"
                    class="tabs-tag tabs-good"
                    :class="{'tabs-active': currentSubIdx === -1}"
                    @click.stop="handleClickSubItem(-1)"
                >{{firstTag}}</li>
                <template v-if="tags">
                    <li
                        v-for="(item, idx) in tags"
                        :class="{
                            'tabs-good': item.commentType === 'good',
                            'tabs-bad': item.commentType === 'bad',
                            'tabs-active': currentSubIdx === idx
                        }"
                        class="tabs-tag"
                        :key="idx"
                        @click.stop="handleClickSubItem(idx)"
                    >{{item[tagLabel]}}{{item.num | addBrackets}}</li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
/**
 * @file tab切换
 * @author guozhihao02
 */
import {on, off} from 'js/Utils';

export default {
    props: {
        tabs: {
            type: Array,
            default: () => []
        },
        firstTab: String,
        needFixed: Boolean,
        tags: {
            type: Array || undefined,
            default: () => []
        },
        firstTab: {
            type: String,
            default: ''
        },
        firstTag: {
            type: String,
            default: ''
        },
        width: {
            type: Number,
            default: 1200
        },
        tabLabel: {
            type: String,
            default: 'value'
        },
        tagLabel: {
            type: String,
            default: 'tag_org'
        },
        defaultTabIdx: Number
    },
    filters: {
        addBrackets(value) {
            return value === void 0 || value === '' || value === null
                ? ''
                : `(${value})`;
        }
    },
    data() {
        return {
            fixed: false,
            currentIdx: -1,
            currentSubIdx: -1,
            height: ''
        };
    },
    watch: {
        tabs(val) {
            this.$nextTick(() => {
                this.height = this.$refs.tabContent.offsetHeight + 'px';
            });
        },
        tags(val) {
            this.$nextTick(() => {
                this.height = this.$refs.tabContent.offsetHeight + 'px';
            });
        }
    },
    mounted() {
        if (typeof this.defaultTabIdx === 'number') {
            this.currentIdx = this.defaultTabIdx;
        }
        else {
            // 判断默认tab
            // 如果有 firstTab 存在，那么值为 -1
            // 如果 firstTab 不存在，那么值为 0
            this.currentIdx = !this.firstTab - 1;
        }
        this.currentSubIdx = !this.firstTag - 1;
        if (this.needFixed) {
            on(window, 'scroll', this.handleScroll);
        }
    },
    deactivated() {
        off(window, 'scroll', this.handleScroll);
    },
    beforeDestroy() {
        off(window, 'scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            const {offsetTop} = this.$refs.tabs;
            let scrollY = window.pageYOffset
                    || document.documentElement.scrollTop
                    || document.body.scrollTop;
            if (offsetTop - scrollY <= 0) {
                this.fixed = true;
            }
            else {
                this.fixed = false;
            }

            // 滚动的时计算下高度, 防止fixed时塌陷
            if (!this.height) {
                this.height = this.$refs.tabContent.offsetHeight + 'px';
            }
        },
        handleClickMainItem(idx) {
            if (this.currentIdx !== idx) {
                this.currentIdx = idx;
                this.currentSubIdx = !this.firstTag - 1;
                this.$emit('change', {
                    type: 'main',
                    value: idx === -1 ? {all: 'all'} : this.tabs[idx],
                    index: idx
                });
            }
        },
        handleClickSubItem(idx) {
            if (this.currentSubIdx !== idx) {
                this.currentSubIdx = idx;
                /* eslint-disable fecs-camelcase */
                this.$emit('change', {
                    type: 'sub',
                    value: idx === -1 ? {all: 'all'} : this.tags[idx],
                    index: idx
                });
                /* eslint-enable fecs-camelcase */
            }
        }
    }
};
</script>

<style lang="less" scoped>
.tabs {
    position: relative;
}
.tabs-content {
    z-index: 9;
    background: #FFFFFF;
    &.tabs-fix {
        position: fixed;
        top: 0;
    }
    .tabs-main {
        padding: 23px 0;
        display: flex;
        border-bottom: 1px solid #EEEEEE;
        li {
            position: relative;
            margin-right: 36px;
            font-size: 20px;
            line-height: 20px;
            color: #666666;
            transition: color .1s linear;
            cursor: pointer;
            img {
                position: absolute;
                opacity: 0;
                width: 8px;
                height: 8px;
                right: -9px;
                top: -4px;
                transition: opacity .1s linear;
            }
            &.tabs-active {
                position: relative;
                font-weight: 500;
                color: #333333;
                img {
                    opacity: 1;
                }
            }
        }
    }
    .tabs-sub {
        display: flex;
        flex-wrap: wrap;
        margin: 16px 0 6px;
        li {
            margin-bottom: 10px;
            margin-right: 10px;
        }
        .tabs-tag {
            padding: 0 12px;
            font-size: 14px;
            height: 30px;
            line-height: 32px;
            border-radius: 4px;
            transition: color, background .1s linear;
            cursor: pointer;
            &.tabs-good {
                color: #00B2B3;
                background: #E3FBFC;
                &.tabs-active {
                    color: #ffffff;
                    background: #00CECF;
                }
            }
            &.tabs-bad {
                color: #999999;
                background: #F5F5F5;
                &.tabs-active {
                    color: #ffffff;
                    background: #A2A9BD;
                }
            }
        }
    }
}
</style>